<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
          icon="mdi-label"
          icon-action="mdi-pencil-outline"
          title="Labels"
          :subtitle="formData.labels && formData.labels.map(i => i.value).join(', ')"
          v-bind="attrs"
          v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Labels
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
            @submit="e => e.preventDefault()"
        >
          <location-list-items v-bind:value="formData.labels" v-on:change="updateData" :limit="10" add-text="Adicionar label" />

          <v-checkbox
              v-if="bulkUpdate"
              :disabled="formData.labels.length === 0 || !formData.labels.every(l => l.value !== '')"
              class="mt-0"
              v-model="formData.increment_label"
              label="Mesclar com labels existentes"
          ></v-checkbox>

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form v-if="!bulkUpdate" small v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem'
import LocationListItems from '@/views/Locations/Components/LocationListItems'
import {mapState} from 'vuex'
import {
  TYPE_UPDATE_LOCATION_LABELS
} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'
import { get } from 'lodash'

export default {
  name: "LocationLabelsModal",
  props: {
    action: Function,
    bulkUpdate: {
      type: Boolean
    },
    alertScheduleTask: Array,
  },
  components: {
    LocationInfoItem,
    LocationListItems,
    ScheduleForm
  },
  methods: {
    getLabelsResume() {
      if (this.formData.labels){
        return this.formData.labels.map(i => i.value).join(', ')
      }
    },
    setInitialData(location) {
      const labels = get(location, 'data.labels', [])
      this.formData.labels = Array.isArray(labels) ? labels.map(i => ({ value: i })) : []
      this.formDataOriginal.labels = Array.isArray(labels) ? labels.map(i => ({ value: i })) : []
    },
    updateData(items) {
      this.formData.labels = items
    },
    cancel() {
      this.open = false
      this.resetData()
    },
    resetData() {
      const labels = get(this.location, 'data.labels', [])
      this.formData.labels = Array.isArray(labels) ? labels.map(i => ({ value: i })) : []
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'labels')
        this.$emit('removePayload', 'increment_label')
      }
    },
    callAction: async function () {
      if (!this.$refs.form.validate()) {
        return false
      }

      const data = { ...this.formData }
      data.labels = Array.isArray(this.formData.labels) && this.formData.labels.length > 0
          ? this.formData.labels.map(i => i.value)
          : null

      if (this.bulkUpdate) {
        this.$emit('savePayload', 'labels', data.labels);
        this.$emit('savePayload', 'increment_label', this.formData.increment_label);
        this.open = false
        return
      } else if (this.action) {
        this.loading = true
        await this.action(data)
        this.loading = false
      }

      this.open = false
    },
    changeScheduleDate(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    },
  },
  computed: {
    ...mapState({
      location: state => state.locations.location
    })
  },
  mounted() {
    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_LABELS) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    formDataOriginal: {},
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_LABELS,
      labels: [],
      increment_label: false,
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: '',
    },
    alertScheduledTask: null,
  }),
  beforeDestroy() {
    this.resetData()
  },
  created() {
    this.setInitialData(this.location)
  },
  watch: {
    location(location) {
      if (!this.bulkUpdate) {
        this.setInitialData(location)
      }
    },
    open(open) {
      if (open && !this.bulkUpdate) {
        this.setInitialData(this.location)
      }
    }
  }
}
</script>

<style scoped>

</style>